// extracted by mini-css-extract-plugin
export default {"content":"ConfirmationDialog_content__Zzq0M"};